import Http from '../../../core/Http';

const publicUrlBase = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

/** public 정적 폴백 (DB/API 실패·빈 응답 시). CRA PUBLIC_URL 반영 */
export const FOOTER_CONTENT_FALLBACK_URL = `${publicUrlBase}/assets/data/footer/footer-content-fallback.json`;

/**
 * 공개 푸터 문서 조회 (DB). 204/실패 시 null
 * 성공 시 응답: footer-content-fallback.json 루트와 동일 shape + footerId, workplaceId(선택)
 */
export async function fetchFooterContentDocument(workplaceId = 1) {
  try {
    const data = await Http.get(`/api/comm/footer-content/workspace/${workplaceId}/latest`);
    if (data == null || data === '' || (typeof data === 'object' && Object.keys(data).length === 0)) {
      return null;
    }
    return data;
  } catch (err) {
    const status = err?.response?.status;
    if (status === 204 || status === 404) return null;
    console.warn('[footerContentApi] API fetch failed:', err?.message);
    return null;
  }
}

/**
 * 정적 폴백 JSON 로드 (fetch, Http 인터셉터 미경유)
 */
export async function loadFooterContentFallbackDocument() {
  try {
    const res = await fetch(FOOTER_CONTENT_FALLBACK_URL, { cache: 'no-store' });
    if (!res.ok) {
      console.warn('[footerContentApi] fallback file HTTP', res.status, FOOTER_CONTENT_FALLBACK_URL);
      return null;
    }
    const json = await res.json();
    if (!json?.footerContent?.footerData) return null;
    return json;
  } catch (e) {
    console.warn('[footerContentApi] fallback json load failed:', e?.message);
    return null;
  }
}

/**
 * API 우선, footerContent.footerData 없거나 API 오류 시 public/footer-content-fallback.json 사용
 */
export async function fetchFooterContentDocumentWithFallback(workplaceId = 1) {
  const apiDoc = await fetchFooterContentDocument(workplaceId);
  if (apiDoc?.footerContent?.footerData) return apiDoc;

  const fallback = await loadFooterContentFallbackDocument();
  if (fallback) {
    console.info('[footerContentApi] Using footer-content-fallback.json (API empty or unavailable)');
    return fallback;
  }
  return null;
}
